export const colors = {
  // -----------------------
  // BRAND - GLOBAL
  // -----------------------
  neutral: {
    x1: '#FFF',
    x2: '#F2F2F2',
    x3: '#E0E0E0',
    x4: '#A3A3A3',
    x5: '#6E6E6E',
    x6: '#525252',
    x7: '#242424',
    x8: '#161616',
    x9: '#000',
  },
  opacity: {
    neutral1: {
      x8: 'rgba(255, 255, 255, 0.08)',
      x16: 'rgba(255, 255, 255, 0.16)',
      x24: 'rgba(255, 255, 255, 0.24)',
      x40: 'rgba(255, 255, 255, 0.4)',
      x64: 'rgba(255, 255, 255, 0.64)',
    },
    neutral9: {
      x8: 'rgba(0, 0, 0, 0.08)',
      x16: 'rgba(0, 0, 0, 0.16)',
      x24: 'rgba(0, 0, 0, 0.24)',
      x40: 'rgba(0, 0, 0, 0.4)',
      x64: 'rgba(0, 0, 0, 0.64)',
    },
  },
  success: {
    x1: '#BCEFC4',
    x2: '#2EBF7C',
    x3: '#00704B',
  },
  caution: {
    x1: '#FFD3D1',
    x2: '#F37C69',
    x3: '#D12D04',
  },

  // -----------------------
  // BRAND - ACCENT
  // -----------------------
  yellow: {
    x1: '#F7F8A4',
    x2: '#FAE57D',
    x3: '#C93D00',
  },
  green: {
    x1: '#BCEFC4',
    x2: '#73BF73',
    x3: '#006716',
  },
  blue: {
    x1: '#B6E4EF',
    x2: '#81CDE5',
    x3: '#002C9E',
  },
  pink: {
    x1: '#FFCEDB',
    x2: '#F598B1',
    x3: '#BF0C2C',
  },
  graph: {
    blue: '#B1E8EF',
    indigo: '#2D75E0',
    green: '#6ECC78',
    yellow: '#F9EA63',
    pink: '#FFB3C6',
    gray: '#8E8E8E',
  },
};

// -----------------------
// SEMANTIC NAMING
// -----------------------
export const semanticColors = {
  border: {
    primary: colors.neutral.x8,
    secondary: colors.neutral.x4,
    tertiary: colors.neutral.x8,
    active: colors.blue.x3,
    caution: colors.caution.x3,
    inversePrimary: colors.neutral.x1,
    inverseSecondary: colors.neutral.x5,
    inverseTertiary: colors.neutral.x1,
    inverseCaution: colors.caution.x2,
  },
  content: {
    primary: colors.neutral.x8,
    secondary: colors.neutral.x5,
    tertiary: colors.neutral.x4,
    accentPrimary: colors.neutral.x8,
    accentSecondary: colors.neutral.x1,
    active: colors.blue.x3,
    success: colors.success.x3,
    caution: colors.caution.x3,
    inversePrimary: colors.neutral.x1,
    inverseSecondary: colors.neutral.x4,
    inverseActive: colors.blue.x2,
    inverseSuccess: colors.success.x2,
    inverseCaution: colors.caution.x2,
  },
  surface: {
    primary: colors.neutral.x1,
    secondary: colors.neutral.x2,
    tertiary: colors.neutral.x3,
    accentPrimary: colors.neutral.x8,
    accentSecondary: colors.neutral.x7,
    active: colors.blue.x2,
    success: colors.success.x1,
    caution: colors.caution.x1,
    inversePrimary: colors.neutral.x8,
    inverseSecondary: colors.neutral.x7,
    inverseTertiary: colors.neutral.x6,
    paper: {
      x1: colors.yellow.x1,
      x2: colors.green.x1,
      x3: colors.blue.x1,
      x4: colors.pink.x1,
    },
  },
  effect: {
    shadowStrong: colors.opacity.neutral9.x24,
    shadowSoft: colors.opacity.neutral9.x16,
    // Not sure if modalOverlay is used this way in Mantine,
    // think we have to set overlay props on the component itself
    modalOverlay: colors.opacity.neutral9.x64,
    imageOverlay: colors.opacity.neutral9.x40,
    modalInverseOverlay: colors.opacity.neutral1.x64,
    pressedOverlay: colors.opacity.neutral9.x8,
    inversePressedOverlay: colors.opacity.neutral1.x16,
  },
};

// -----------------------
// Overrides of Mantine color defaults
// -----------------------
// NOTE: we don't have a '0' value so reusing our '1' values for their '0'
// Also for our accent colors we only use 1-3, but we need to fill in
// the rest of the values for a total ot 10 per custom color
export const customMantineColors = {
  neutral: [
    colors.neutral.x1,
    colors.neutral.x1,
    colors.neutral.x2,
    colors.neutral.x3,
    colors.neutral.x4,
    colors.neutral.x5,
    colors.neutral.x6,
    colors.neutral.x7,
    colors.neutral.x8,
    colors.neutral.x9,
  ],
  dark: [
    colors.neutral.x1,
    colors.neutral.x1,
    colors.neutral.x2,
    colors.neutral.x3,
    colors.neutral.x4,
    colors.neutral.x5,
    colors.neutral.x7,
    colors.neutral.x7,
    colors.neutral.x8,
    colors.neutral.x9,
  ],
  yellow: [
    colors.yellow.x1,
    colors.yellow.x1,
    colors.yellow.x2,
    colors.yellow.x3,
    colors.yellow.x3,
    colors.yellow.x3,
    colors.yellow.x3,
    colors.yellow.x3,
    colors.yellow.x3,
  ],
  green: [
    colors.green.x1,
    colors.green.x1,
    colors.green.x2,
    colors.green.x3,
    colors.green.x3,
    colors.green.x3,
    colors.green.x3,
    colors.green.x3,
    colors.green.x3,
  ],
  blue: [
    colors.blue.x1,
    colors.blue.x1,
    colors.blue.x2,
    colors.blue.x3,
    colors.blue.x3,
    colors.blue.x3,
    colors.blue.x3,
    colors.blue.x3,
    colors.blue.x3,
  ],
  pink: [
    colors.pink.x1,
    colors.pink.x1,
    colors.pink.x2,
    colors.pink.x3,
    colors.pink.x3,
    colors.pink.x3,
    colors.pink.x3,
    colors.pink.x3,
    colors.pink.x3,
  ],
};

// -----------------------
// DARK MODE SEMANTIC NAMING
// -----------------------
export const semanticColorsDark = {
  border: {
    primary: colors.neutral.x4,
    secondary: colors.neutral.x6,
    tertiary: colors.neutral.x4,
    active: colors.blue.x2,
    caution: colors.caution.x2,
    inversePrimary: colors.neutral.x8,
    inverseSecondary: colors.neutral.x4,
    inverseTertiary: colors.neutral.x8,
    inverseCaution: colors.caution.x2,
  },
  content: {
    primary: colors.neutral.x3,
    secondary: colors.neutral.x4,
    tertiary: colors.neutral.x5,
    accentPrimary: colors.neutral.x8,
    accentSecondary: colors.neutral.x3,
    active: colors.blue.x1,
    success: colors.success.x2,
    caution: colors.caution.x2,
    inversePrimary: colors.neutral.x8,
    inverseSecondary: colors.neutral.x6,
    inverseActive: colors.blue.x2,
    inverseSuccess: colors.success.x2,
    inverseCaution: colors.caution.x2,
  },
  surface: {
    primary: colors.neutral.x7,
    secondary: colors.neutral.x8,
    tertiary: colors.neutral.x6,
    accentPrimary: colors.neutral.x7,
    accentSecondary: colors.neutral.x8,
    active: colors.blue.x2,
    success: colors.success.x1,
    caution: colors.caution.x1,
    inversePrimary: colors.neutral.x3,
    inverseSecondary: colors.neutral.x4,
    inverseTertiary: colors.neutral.x5,
    paper: {
      x1: colors.yellow.x1,
      x2: colors.green.x1,
      x3: colors.blue.x1,
      x4: colors.pink.x1,
    },
  },
  effect: {
    shadowStrong: colors.opacity.neutral9.x24,
    shadowSoft: colors.opacity.neutral9.x16,
    // Not sure if modalOverlay is used this way in Mantine,
    // think we have to set overlay props on the component itself
    modalOverlay: colors.opacity.neutral9.x64,
    imageOverlay: colors.opacity.neutral9.x40,
    modalInverseOverlay: colors.opacity.neutral1.x64,
    pressedOverlay: colors.opacity.neutral9.x8,
    inversePressedOverlay: colors.opacity.neutral1.x16,
  },
};
